import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  IconButton,
  Stepper,
  Step,
  StepLabel,
  Divider,
  Alert,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Compact modal shell for CSV import flows.
 * Renders: title, subtitle, stepper, optional error, and step content (children).
 */
const ImportCSVModalShell = ({
  open,
  onClose,
  title,
  subtitle,
  steps = ['Select CSV', 'Preview', 'Done'],
  activeStep = 0,
  error,
  onErrorDismiss,
  children,
}) => (
  <Dialog
    open={!!open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: 2,
        maxHeight: '85vh',
        minHeight: 320,
      },
    }}
  >
    <DialogTitle sx={{ py: 1.5, px: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box>
          <Typography variant="subtitle1" fontWeight={700}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        <IconButton size="small" onClick={onClose} sx={{ ml: 0.5 }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    </DialogTitle>
    <Divider />
    <DialogContent sx={{ pt: 1.5, px: 2, pb: 2 }}>
      <Stepper activeStep={activeStep} sx={{ pt: 0, pb: 2 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel sx={{ '& .MuiStepLabel-label': { fontSize: '0.8rem' } }}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {error && (
        <Alert severity="error" sx={{ mb: 1.5 }} onClose={onErrorDismiss}>
          {error}
        </Alert>
      )}
      {children}
    </DialogContent>
  </Dialog>
);

export default ImportCSVModalShell;
